module.exports = __webpack_public_path__ + "static/img/blog_1.9520603.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/blog/blog_1.jpg
// module id = 8fkj
// module chunks = 1